import type { SectionWithArticles } from '../hooks/useManualNavigation';

interface NavigationSectionProps {
  section: SectionWithArticles;
  isExpanded: boolean;
  currentPath?: string;
  onToggle: () => void;
  onNavigate: (path: string) => void;
}

export function NavigationSection({
  section,
  isExpanded,
  currentPath,
  onToggle,
  onNavigate,
}: NavigationSectionProps) {
  return (
    <div className="manual-nav-section">
      <button
        className={`manual-nav-section-title ${isExpanded ? 'expanded' : ''}`}
        onClick={onToggle}
      >
        <span className="manual-nav-section-icon">
          {isExpanded ? '▼' : '▶'}
        </span>
        {section.title}
      </button>
      {isExpanded && (
        <div className="manual-nav-items">
          {section.articles.map((article) => {
            const articlePath = `/manual/article/${article.slug}`;
            return (
              <button
                key={article.id}
                className={`manual-nav-item ${currentPath === articlePath ? 'active' : ''}`}
                onClick={() => onNavigate(articlePath)}
              >
                {article.title}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
